import { EnumDropdownItemVariant, type IDropdownItem } from 'shared/ui'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import { type ISendFromStoreItem } from 'widgets/SendFrom/store/type'

export const getShortCodeDropdownItem = (
  inbox: Inbox,
  children?: IDropdownItem<ISendFromStoreItem>[],
  options?: { disabledClosedTooltip?: true }
): IDropdownItem<ISendFromStoreItem> | null => {
  const disabledClosedTooltip = options?.disabledClosedTooltip
  const number = inbox.number
  if (!number) return null
  return {
    id: inbox.id,
    children,
    disabledClosedTooltip,
    searchPattern: `${inbox.name}${number.number}${number.formatted_number}${number.national_number}}`,
    group: 'Short codes',
    label: `${inbox.number?.national_number}: ${inbox.name}`,
    ariaLabel: 'SelectDropdownShortCode',
    data: {
      inbox,
      number,
    },
    iconL: inbox.icon,
    isCardClick: true,
    variant: EnumDropdownItemVariant.Default,
  }
}
